import useTranslation from '../../../../../hooks/translation/useTranslation';
import { useBooking } from '../../../../../contexts/ticketBookingContext/TicketBookingContext';

function FillPassengersNavigationItem({
  lastName,
  firstName,
  seatGroup,
  price = 0,
  seatNumber,
  carriageId,
  passengerNumber,
  seatClassId = null,
  direction = 'departure',
}) {
  const { trans } = useTranslation();
  const { bookingData } = useBooking();
  const seatClass = bookingData?.[direction]?.availableSeatsClasses?.find(
    (item) => item.seatClass.id === seatClassId,
  );

  return (
    <li className="flex gap-4 flex-wrap" key={`${carriageId}_${seatNumber}`}>
      <p className="m-0 text-sm">{seatNumber}</p>
      {seatClass && <p className="m-0 text-sm">{seatGroup === 12 ? trans('wheelchair') : trans(seatClass?.seatClass?.name)}</p>}
      <p className="grow m-0 text-sm">
        {firstName && lastName
          ? `${firstName?.[0]}.${lastName}`
          : `${trans('passenger')} ${passengerNumber}`}
      </p>
      <p className="m-0 text-sm">
        {price}
        {trans('gel')}
      </p>
    </li>
  );
}

export default FillPassengersNavigationItem;
